import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC032_Request,
  IAPI_FAC032_Response,
} from "../../../type/apiType/index";

// 施設一覧参照(従業状況の更新)API
const httpIAPI_FAC032 = async (
  param: IAPI_FAC032_Request
): Promise<IAPI_FAC032_Response> => {
  let res = await http.post(ApiUrl.API_FAC032, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_FAC032 };
